import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';


export default class AddMoleculePopup extends React.Component {

  constructor() {
    super();
    let molecules = [{
      type: 'web_stasher',
      name: 'web',
      title: 'Web Molecule',
      fields: [{
        type: 'url',
        name: 'url',
        title: 'Site Address',
        hint: 'http://somesite.com/article/1',
        primary: true,
      }]
    }, {
      type: 'note_stasher',
      name: 'note',
      title: 'Note Molecule',
      fields: [{
        type: 'txt',
        name: 'note',
        title: 'Note',
        hint: 'Enter your note here',
        primary: true,
        rows: 1,
      }, {
        type: 'txt',
        name: 'title',
        title: 'Note title',
        hint: 'Name your note here',
      }, {
        type: 'txt',
        name: 'description',
        title: 'Short description what this note is about',
        hint: 'This is the list of all movies i need to see',
      }]
    }];
    this.state = {
      molecules: molecules,
      molecule: this.getMoleculeByType('web_stasher', molecules),
      data: {},
    };
  }

  getMoleculeByType(type, molecules=null) {
    let items = molecules || this.state.molecules;
    for (let molecule of items) {
      if (molecule.type === type) {
        return molecule;
      }
    }
  }

  onDone() {
    if (this.props.onAdd) {
      this.props.onAdd(this.state.molecule, this.state.data);
    }
  }

  generateFields() {
    if (!this.state.molecule.fields) {
      return null;
    }
    return this.state.molecule.fields.map((field, index) => {
      let props = {
        hintText: field.hint,
        floatingLabelText: field.title,
        fullWidth: true,
      };
      if (field.type === 'txt' || field.type === 'url') {
        if (field.rows) {
          props.rows = field.rows;
          props.multiLine = true;
        }
        if (field.primary) {
          props.autoFocus = true;
        }
        return (
          <div key={field.name}>
            <TextField
              {...props}
              onKeyDown={(e) => {
                if (e.ctrlKey && e.key === 'Enter') {
                  this.onDone();
                }
              }}
              onChange={(e) => {
                let newState = {...this.state};
                newState['data'][field.name] = e.target.value;
                this.setState(newState);
              }}
            />
          </div>
        );
      }
      return null;
    });
  }

  render() {
    return (
      <div>
        <Dialog
          title="Add Molecule"
          titleStyle={{
            color: '#fff',
            backgroundColor: 'rgb(26, 198, 255)',
          }}
          actions={[
            <FlatButton
              label="Add"
              primary={true}
              onTouchTap={() => {
                this.onDone();
              }}
            />,
            <FlatButton
              label="Cancel"
              primary={true}
              onTouchTap={() => {
                if (this.props.onCancel) {
                  this.props.onCancel();
                }
              }}
            />,
          ]}
          modal={false}
          open={this.props.open}
          onRequestClose={() => {
            if (this.props.onCancel) {
              this.props.onCancel();
            }
          }}
          autoScrollBodyContent={true}
        >
          <div>
            <SelectField
              floatingLabelText="Molecule type"
              value={this.state.molecule.type}
              onChange={(event, index, value) => {
                // clear data on molecule type change
                this.setState({
                  ...this.state,
                  molecule: this.getMoleculeByType(value),
                  data: {},
                });
              }}
            >
              {this.state.molecules.map((molecule, index) => {
                return (<MenuItem
                  key={molecule.type}
                  value={molecule.type}
                  primaryText={molecule.name}
                />);
              })}
            </SelectField>
          </div>
          <div>
          {this.generateFields()}
          </div>
        </Dialog>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/AddMoleculePopup.jsx